import { Injectable, signal } from '@angular/core';
import { environment } from '../environments/environment';

declare const google: any;

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {
  isLoaded = signal(false);
  private loadingPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (this.isLoaded()) {
      return Promise.resolve();
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise((resolve, reject) => {
      if (typeof google !== 'undefined' && google.maps) {
        this.isLoaded.set(true);
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places&v=beta`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.isLoaded.set(true);
        this.loadingPromise = null;
        resolve();
      };

      script.onerror = (error) => {
        this.loadingPromise = null;
        reject(error);
      };

      document.head.appendChild(script);
    });

    return this.loadingPromise;
  }
}
